/**
 * Smart Waste Frontend - Entry Point
 *
 * Main entry point for the React application
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress AbortError overlay - caused by Supabase/timeouts when requests are aborted
// (navigation, Strict Mode remount, or timeout). Benign; does not affect app behavior.
window.addEventListener('unhandledrejection', (e) => {
  const reason = e.reason;
  const isAbort = reason?.name === 'AbortError' || 
                  reason?.message?.includes('AbortError') || 
                  reason?.message?.includes('signal is aborted') ||
                  String(reason)?.includes('AbortError') ||
                  String(reason)?.includes('signal is aborted');
  if (isAbort) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
});

window.addEventListener('error', (e) => {
  const isAbort = e.error?.name === 'AbortError' || 
                  e.message?.includes('AbortError') || 
                  e.message?.includes('signal is aborted') ||
                  e.error?.message?.includes('signal is aborted');
  if (isAbort) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
